/**
 * reference: https://upmostly.com/tutorials/how-to-use-the-usecontext-hook-in-react
 */
import React, {
    useState
} from 'react';

const InventoryContext = React.createContext([{}, () => {}]);

const InventoryProvider = (props) => {
    const [state, setState] = useState({
        isLoading: false,
        isLoaded: false,
        inventory: [],
    });

    return (
        <InventoryContext.Provider value={[state, setState]}>
            {props.children}
        </InventoryContext.Provider>
    );
};

export { InventoryContext, InventoryProvider };